import { resourceExplorerDimensionSelector } from "./resourceExplorerDimensionSelector";
import { RootState } from "../../../../store";

export const resourceExplorerDimensionIdSelector = (state: RootState) => {
  return resourceExplorerDimensionSelector(state)?.dimensionId;
};
